import { render, staticRenderFns } from "./FreePlaces.vue?vue&type=template&id=65b461b7&"
import script from "./FreePlaces.vue?vue&type=script&lang=js&"
export * from "./FreePlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports